
(function () {
  function hideInternalFields() {
    document.querySelectorAll(
      "#cart-drawer .cart-property-row"
    ).forEach(function (row) {
      var text = row.textContent.trim();

      if (
        text.startsWith("_tpo_") ||
        text.startsWith("_po:")
      ) {
        row.style.display = "none";
      }
    });
  }

  function start() {
    hideInternalFields();

    var cart = document.querySelector("#cart-drawer");
    if (!cart) return;

    var observer = new MutationObserver(hideInternalFields);

    observer.observe(cart, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
